import { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import NavbarTopAdmin from './components/navbarTopAdmin'
import NavbarBottomAdmin from './components/navbarBottomAdmin'
import AuthProvider from '../Authentication/authProvider'

function CheckArtisti() {
    const [artisti, setArtisti] = useState([])
    const [artistiImmutabile, setArtistiImmutabile] = useState([])
    const [dati, setDati] = useState({})
    const [titolo, setTitolo] = useState('Tutti gli artisti')
    const [dimensione, setDimensione] = useState(null)

    const divDettagli = useRef()
    const confirmElimina = useRef()
    const details = {
        display: 'grid', gridTemplateColumns: '0.2fr 1fr', gap: '5px'
    }

    const getArtisti = () => {
        axios.post('/getArtisti/ASC/nome').then(res => {
            const rty = res.data.filter(item => item.sezione === 'artista')
            setArtisti(rty)
            setArtistiImmutabile(rty)
        }).catch((err) => { console.error(err) })
    }

    const dettagli = async (e) => {
        setDati(e)
        if (e.video) {
            axios.get(`/video-size/${e.video}`).then(res => { setDimensione(res.data.sizeMB) })
        }
        divDettagli.current.style.top = '0'
    }
    const approva = async (stato) => {
        try {
            axios.post(`/approvaArtista/${dati.id}/${dati.emailUser}/${stato}/${dati.idUser}`).then(res => {
                divDettagli.current.style.width = '0px'
                divDettagli.current.style.left = '-20%'
                document.body.style.overflow = "scroll"
                if (stato === 'delete') {
                    if (dati.img) axios.delete(`/delete-img/${dati.img}`)

                    if (dati.video) axios.delete(`/delete-video/${dati.video}`)
                }
                setTimeout(() => { window.location.reload() }, 2000)
            })
        } catch (err) { console.log(err) }
    }
    useEffect(() => { getArtisti() }, [])
    // useEffect(() => { console.log('artisti:', artisti) }, [artisti])
    return (<>
        <AuthProvider />
        <NavbarTopAdmin />
        <NavbarBottomAdmin />
        {/* <AuthProvider /> */}
        <div style={{ margin: '8rem 0 10rem 0' }}>
            <div className='mt-4' style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '5px', marginLeft: '1em' }}>
                <div>
                    <button onClick={() => {
                        setArtisti(artistiImmutabile.filter(item => item.accettazione === 'false'))
                        setTitolo('Artisti da approvare')
                    }} className='btn btn-warning'>NoAccep
                    </button>
                </div>
                <div>
                    <button onClick={() => {
                        setArtisti(artistiImmutabile.filter(item => item.accettazione === 'rejection'))
                        setTitolo('Artisti rifiutati')
                    }} className='btn btn-danger'>Reject
                    </button>
                </div>
                <div>
                    <button onClick={() => {
                        setArtisti(artistiImmutabile.filter(item => item.accettazione === 'true'))
                        setTitolo('Artisti approvati')
                    }} className='btn btn-success'>Accept
                    </button>
                </div>
                <div>
                    <button onClick={() => {
                        setArtisti(artistiImmutabile)
                        setTitolo('Tutti gli artisti')
                    }} className='btn btn-primary'>Tutti
                    </button>
                </div>
            </div><hr />
            <p className='fs-4 text-center mt-5' style={{ color: 'navy' }}><b>{titolo}</b></p>
            {artisti &&
                <div style={{ position: 'relative' }}>
                    <table className="table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Nome</th>
                                <th className='thDesk'>Gruppo</th>
                                <th>Genere</th>
                                <th>Video</th>
                                <th className='thDesk'>Città</th>
                                <th className='thDesk'>Email</th>
                                <th className='thDesk'>User</th>
                            </tr>
                        </thead>
                        <tbody>
                            {artisti.map(artista => {
                                let flag
                                switch (artista.accettazione) {
                                    case 'true': flag = 'lawngreen'; break
                                    case 'false': flag = 'orange'; break
                                    case 'rejection': flag = 'red'; break
                                    default: flag = 'transparent'
                                }
                                return (
                                    <tr onClick={() => { dettagli(artista) }} key={artista.id} style={{ cursor: 'pointer' }}>
                                        <td><div style={{
                                            borderRadius: '50px',
                                            width: '7px',
                                            height: '7px',
                                            marginTop: '12px',
                                            backgroundColor: flag
                                        }}></div>
                                        </td>
                                        <td>{artista.nome} {artista.cognome}</td>
                                        <td className='thDesk'>{artista.gruppo}</td>
                                        <td>{artista.genere}</td>
                                        <td>{artista.video ? <span>Vid</span> : null}</td>
                                        <td className='thDesk'>{artista.città}</td>
                                        <td className='thDesk'>{artista.email}</td>
                                        <td className='thDesk'>{artista.idUser}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    {!artisti && <h3 className='m-3'>Nessuna artista da mostrare</h3>}

                    {/* ---------- BANEER DETTAGLI ---------- */}
                    <div className='visualDettagli' ref={divDettagli}>
                        {dati.id &&
                            <div style={{ marginBottom: '6rem' }}>
                                <span style={{ fontSize: '2rem', float: 'right', cursor: 'pointer' }} onClick={() => {
                                    divDettagli.current.style.top = '120%'
                                }}>X
                                </span><br />
                                <h4>
                                    {dati.accettazione === 'true' && <span style={{ color: 'mediumseagreen' }}>Artista in-line</span>}
                                    {dati.accettazione === 'false' && <span style={{ color: 'orangered' }}>Artista da approvare</span>}
                                    {dati.accettazione === 'rejection' && <span style={{ color: 'red' }}>Artista rifiutato</span>}
                                </h4> <hr />
                                {dati.img &&
                                    <div className='mt-1'>
                                        <p>IMMAGINE CARICATA</p>
                                        <img src={`https://leuro-bucket.s3.amazonaws.com/${dati.img}`} width={150} height={150} />
                                    </div>
                                }
                                <div style={{ border: '1px solid lightgray', borderRadius: '5px', marginTop: '3rem', padding: '5px' }}>
                                    <p>DATI DI LOGIN:</p>
                                    <div style={details}>
                                        <div>User Id:</div><div>{dati.idUser}</div>
                                        <div>Email user:</div><div>{dati.emailUser}</div>
                                    </div>
                                </div>

                                <h5 className='mt-3'>DATI ARTISTA:</h5>
                                <div style={details}>
                                    <div>Nome:</div><div>{dati.nome}</div>
                                    <div>Cognome:</div><div>{dati.cognome}</div>
                                    <div>Gruppo:</div><div>{dati.gruppo}</div>
                                    <div>Genere:</div><div>{dati.genere}</div>
                                    <div>N. comp:</div><div>{dati.numero} elementi</div>
                                    <div>Regione:</div><div>{dati.regione}</div>
                                    <div>Città:</div><div>{dati.città}</div>
                                </div>
                                {dati.durata &&
                                    <div style={details}>
                                        <div>Durata show:</div><div>{dati.durata}</div>
                                    </div>
                                }
                                <div style={details}>
                                    <div>Email:</div><div>{dati.emailUser}</div>
                                </div>
                                {dati.telefono &&
                                    <div style={details}>
                                        <div>Telefono:</div><div>{dati.telefono}</div>
                                    </div>
                                }
                                {/* ----------------------------- VIDEO --------------------------- */}
                                {dati.video &&
                                    <div className='mt-3'>
                                        <video src={`https://leuro-bucket.s3.amazonaws.com/video/${dati.video}`} style={{ maxWidth: '100%', height: '200px' }} controls />
                                        <p><b>{dimensione} MB</b> <br />{dati.video}</p>
                                    </div>
                                }
                                <div style={details}>
                                    <div>Creato il: </div><div>{dati.created_at}</div>
                                    <div>ID: </div><div>{dati.id}</div>
                                </div>
                                <textarea value={dati.descrizione} style={{ fontStyle: 'italic', fontSize: '13px', marginTop: '2rem' }} rows={8} className='form-control' />

                                <div style={{ border: '1px solid lightgrey', borderRadius: '20px', padding: '15px 5px', marginTop: '2rem' }}>
                                    <h5 style={{ fontFamily: 'sans-serif' }}>LINK</h5>
                                    {dati.url &&
                                        <div className='btn btn-warning'>
                                            <a href={dati.url} style={{ textDecoration: 'none', color: 'navy' }} target='_blank'>Sito web</a>
                                        </div>
                                    }
                                    {dati.fb &&
                                        <span style={{ backgroundColor: 'royalblue', borderRadius: '25px', marginLeft: '1rem', padding: '5px 13px' }}>
                                            <a href={dati.fb} style={{ textDecoration: 'none', color: 'white', fontSize: 'x-large' }} target='_blank'><b>f</b></a>
                                        </span>
                                    }
                                    {dati.youtube &&
                                        <span style={{ backgroundColor: 'red', borderRadius: '25px', marginLeft: '1rem', padding: '5px 13px' }}>
                                            <a href={dati.youtube} style={{ textDecoration: 'none', color: 'white' }} target='_blank'><b>▷</b></a>
                                        </span>
                                    }
                                </div>

                                <div className='mt-5'>
                                    <button className='btn btn-success float-start' onClick={() => { approva(true) }}>
                                        Approva
                                    </button>

                                    <button className='btn btn-dark' style={{ marginLeft: '20%' }}
                                        onClick={() => { confirmElimina.current.style.display = 'block' }}>
                                        Elimina
                                    </button>

                                    <button className='btn btn-danger float-end'
                                        onClick={() => { approva(null) }}>
                                        Rifiuta
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
        <div ref={confirmElimina} style={{
            display: 'none',
            position: 'fixed',
            backgroundColor: 'cornsilk',
            top: '30%',
            left: '0',
            right: '0',
            margin: 'auto',
            width: '70%',
            height: '40%',
            padding: '2rem',
            zIndex: '1',
            borderRadius: '10px'
        }}>
            Eliminare definitivamente {dati.titolo}?
            <div className='mt-5'>
                <button className='float-start btn btn-danger'
                    onClick={() => {
                        confirmElimina.current.style.display = 'none'
                        approva('delete')
                    }}>Elimina</button>
                <button className='float-end btn btn-success'
                    onClick={() => { confirmElimina.current.style.display = 'none' }}>Annulla</button>
            </div>
        </div>
    </>
    )
}
export default CheckArtisti